var _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorporateVideoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 33,
    viewBox: "0 0 42 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 32L41 32",
    stroke: "white",
    strokeLinecap: "round",
    strokeDasharray: "3 3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41 9L41 32",
    stroke: "white",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.999999 4L1.00001 32",
    stroke: "white",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 4.00004L30.5 4",
    stroke: "white",
    strokeLinecap: "round",
    strokeDasharray: "3 3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4948 2.83907L33.2539 6.25781M38.9887 0.99872C39.2571 0.99872 39.5146 1.10261 39.7044 1.28754C39.8941 1.47246 40.0008 1.72328 40.0008 1.9848C40.0008 2.24632 39.8941 2.49714 39.7044 2.68206C39.5146 2.86699 39.2571 2.97088 38.9887 2.97088C38.7203 2.97088 38.4629 2.86699 38.2731 2.68206C38.0833 2.49714 37.9767 2.24632 37.9767 1.9848C37.9767 1.72328 38.0833 1.47246 38.2731 1.28754C38.4629 1.10261 38.7203 0.99872 38.9887 0.99872Z",
    stroke: "white",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2408 5.21171L33 1.79297M39.4504 6.76325C39.2607 6.94817 39.0032 7.05206 38.7348 7.05206C38.4664 7.05206 38.209 6.94817 38.0192 6.76325C37.8294 6.57832 37.7228 6.32751 37.7228 6.06598C37.7228 5.80446 37.8294 5.55364 38.0192 5.36872C38.209 5.18379 38.4664 5.0799 38.7348 5.0799",
    stroke: "white",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3901 18.5769C25.7015 18.773 25.7015 19.227 25.3901 19.4231L20.0165 22.8076C19.6835 23.0173 19.25 22.778 19.25 22.3845L19.25 15.6155C19.25 15.222 19.6835 14.9827 20.0165 15.1924L25.3901 18.5769Z",
    stroke: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 11.5,
    width: 22,
    height: 15,
    rx: 0.5,
    stroke: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 8.5,
    width: 11,
    height: 3,
    rx: 0.5,
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporateVideoIcon);
export default __webpack_public_path__ + "static/media/corporateVideoIcon.db78167956d3f47a597c93fa7fad8d8f.svg";
export { ForwardRef as ReactComponent };